import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const SignUpComplete = () => {
  localStorage.removeItem('nonMemberRecommendCode');
  const navigate = useNavigate();

  useEffect(() => {
    const handleBack = () => {
      navigate('/', { replace: true }); // 뒤로가기 시 홈으로 이동
    };

    window.addEventListener('popstate', handleBack);

    return () => {
      window.removeEventListener('popstate', handleBack);
    };
  }, [navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-757069784/ZuKLCILR9s4aENjv_-gC',
      });
    }
  }, []);

  useEffect(() => {
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      fbq('track', 'CompleteRegistration');
    `;
    document.body.appendChild(inlineScript);

    return () => {
      document.body.removeChild(inlineScript);
    };
  }, []);

  return (
    <>
      <Helmet>
        <script type="text/javascript" src="//wcs.naver.net/wcslog.js"></script>
        <script type="text/javascript">
          {`if(window.wcs){
    if(!wcs_add) var wcs_add = {};
    wcs_add['wa'] = 's_2489d344048e';
    var _conv = {};
    	_conv.type = 'sign_up';    	
    wcs.trans(_conv);
    }`}
        </script>
      </Helmet>
      <div style={styles.container}>
        <div style={styles.scrollContainer}>
          <div
            style={{
              padding: '16px',
            }}
          >
            <img
              onClick={() => {
                navigate(-1);
              }}
              src="/assets/images/arrow/back-arrow-left-gray.svg"
            ></img>
          </div>
          <div style={styles.contentWrapper}>
            <div style={styles.content}>
              <img
                src="/assets/images/check/blue_check_48.svg"
                alt=""
                width={80}
              />
              <div style={styles.textbox}>
                <span style={styles.textrow1}>
                  {sessionStorage.getItem('name')}님, 환영합니다.
                </span>
                <div style={styles.infoBox}>
                  <div>회원가입이 완료되었습니다.</div>
                  <div style={{ textAlign: 'center' }}>
                    빅데이터 기반 돈 되는 경공매 분석 서비스를
                    <br />
                    바로 이용해 보세요!
                  </div>
                </div>
              </div>
            </div>
            <div
              onClick={() => {
                navigate('/login');
                sessionStorage.clear();
              }}
              style={styles.button}
            >
              <span style={styles.buttonText}>
                로그인하고 무료체험 시작하기
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUpComplete;

const styles = {
  infoBox: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    justiFyContent: 'center',
    alignItems: 'center',
    color: '#616161',
    fontSize: '14px',
    fontFamily: 'Spoqa Han Sans Neo',
    fontWeight: 500,
    lineHeight: '23.20px',
  },
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    backgroundColor: '#FFFFFF',
  },
  scrollContainer: {
    flexGrow: 1,
    width: '100%',
    height: '100vh',
  },
  contentWrapper: {
    alignItems: 'center',
    gap: 64,
    padding: '40px 16px',
    width: '100%',
    height: 'calc(100% - 61px)',
    display: 'flex',
    flexDirection: 'column' as 'column',
    justifyContent: 'space-between',
  },
  content: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 24,
  },
  textbox: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 16,
  },
  button: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#008AFF',
    borderRadius: 8,
    cursor: 'pointer',
    padding: '14px 28px',
    display: 'flex',
  },
  buttonText: {
    color: 'white',
    fontFamily: 'Spoqa Han Sans Neo',
    fontWeight: '700',
    fontSize: '16px',
  },
  textrow1: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '34.8px',
    color: '#171E26',
    textAlign: 'center' as 'center',
  },
  textrow2: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '23.2px',
    color: '#454D53',
    textAlign: 'center' as 'center',
  },
};
